import styled from "styled-components";

// Página inteira (não modal). Não usa o `Main`/`.content` antigo de ui/modules/styled.js
// de propósito: o `.content button` dele pinta TODO botão de verde.
export const Tela = styled.main`
  width: 100%;
  min-width: 0;
  height: 100vh;
  overflow-y: auto;
  padding: 32px 48px 56px;
  background: #fff;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 20px;

  .migalhas{
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #6B6E70;
    a{ color: var(--primary-color); font-weight: 600; text-decoration: none; &:hover{ text-decoration: underline; } }
    [aria-current]{ color: #1E1F20; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  }

  .capa{
    width: 100%;
    height: clamp(180px, 30vh, 320px);
    border-radius: 14px;
    overflow: hidden;
    background: #E3EDE6;
    img{ width: 100%; height: 100%; object-fit: cover; display: block; }
  }

  .grade{
    display: grid;
    grid-template-columns: minmax(0, 1fr) 320px;
    gap: 32px;
    align-items: start;
  }

  .principal{
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 22px;

    h1{ margin: 0; font-size: 30px; font-weight: 700; line-height: 125%; color: #1f7a33; overflow-wrap: anywhere; }
    h2{ margin: 0 0 8px; font-size: 18px; font-weight: 700; color: #1f7a33; }

    .meta{ display: flex; flex-wrap: wrap; align-items: center; gap: 8px 18px; font-size: 14px; color: #4D4F50; }
    .meta-item{ display: inline-flex; align-items: center; gap: 6px; img{ width: 14px; } }
    .selo{ padding: 2px 10px; border-radius: 10px; font-size: 12px; font-weight: 700; background: #E4F4E7; color: #1f7a33; border: 1px solid #BFE0C5; }

    .sobre{ margin: 0; font-size: 16px; line-height: 160%; color: #1E1F20; white-space: pre-wrap; overflow-wrap: anywhere; }

    .pessoas{
      list-style: none; margin: 0; padding: 0;
      display: flex; flex-wrap: wrap; gap: 12px 24px;
      li{ display: flex; align-items: center; gap: 10px; font-size: 15px; font-weight: 600; }
    }
  }

  .lateral{
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 20px;
    border: 1px solid #EFF0F2;
    border-radius: 14px;
    background: #FAFBFA;

    .estado{ margin: 0; font-size: 14px; line-height: 150%; color: #4D4F50; &.ok{ color: #1f7a33; font-weight: 600; } }
    .erro{ font-size: 13px; color: #C43333; }

    .participantes{
      border-top: 1px solid #EFF0F2;
      padding-top: 14px;
      h3{ margin: 0 0 10px; font-size: 14px; font-weight: 700; color: #4D4F50; }
      .avatares{ display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
      .mais{ font-size: 13px; font-weight: 700; color: #6B6E70; }
    }
  }

  .botao{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    padding: 0 16px;
    border: 1.5px solid var(--primary-color);
    border-radius: 8px;
    background: var(--primary-color);
    color: #fff;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;
    &:disabled{ opacity: .6; cursor: default; }
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
    &.secundario{ background: transparent; color: var(--primary-color); }
  }

  .vazio{
    padding: 40px 0;
    h2{ margin: 0 0 8px; }
    p{ margin: 0 0 18px; color: #4D4F50; }
    .botao{ width: auto; display: inline-flex; }
  }

  @media screen and (max-width: 960px){
    padding: 20px 16px 40px;
    .grade{ grid-template-columns: minmax(0, 1fr); }
    .lateral{ position: static; order: -1; }
    .principal h1{ font-size: 24px; }
  }
`;
